var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false},on:{"addEvent":function($event){return _vm.$router.push({name: 'addProduct'})}}},[_vm._v("المراجعات")]),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":"merchant/reviews"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }